import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {map} from 'rxjs/operators';
import {AuthService} from './auth.service';
import { environment } from 'src/environments/environment';
import { ParamService } from './param.service';

declare let $: any;

@Injectable({
    providedIn: 'root'
})
export class CouponGridService {

    freshpassEvents: Array<string> = ['freshpass deals', 'freshpass perks', 'freshpass credit'];
    public objPageCoupons = {
        'offers': {},
        'offersByUpc': {}
    };
    public couponUpdated = new Subject();
    public shopCouponRefreshSource = new BehaviorSubject<boolean>(false);
    public shopCouponRefresh = this.shopCouponRefreshSource.asObservable();
    private objCoupons = {};
    private banner;
    constructor(private _http: HttpClient, public authService: AuthService, private paramService: ParamService) {
      this.banner = this.paramService.banner;
    }

    public getCoupons(userInfo) {
        const url = this.authService.getApplicationDomainURL() + window['AB'].xAPIgalleryPath + "?storeId=" + userInfo.j4uStoreId;
        let headerObj = window['AB'].companionOffersxAPIHttpOptions
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
            }
        };
        return this._http.get(url, options);
    }

    public filterCoupons(data) {
        let mappedCoupons = this.mapCoupons(data, false);
        let objCoupons = mappedCoupons['coupons'];
        let coupons;
        if (objCoupons) {
            coupons = Object.values(data['companionGalleryOffer']).filter((coupon: any) => {
                if (coupon.events && coupon.events.length > 0) {
                    console.log(coupon.events)
                    return coupon.events.some((event) => this.freshpassEvents.includes(event.toLowerCase()))
                }
                return false
            });
        }
        return coupons;
    }
    public getCouponsByProgramType(userInfo, currentEnvironment, programType: string[]) {
        const payload = JSON.stringify({
            programType: programType
        })
        const offersUrl = this.authService.getApplicationDomainURL() + environment[currentEnvironment].getOffersGalleryFilterApi.url + "?storeId=" + userInfo.j4uStoreId;
        let headerObj = environment[currentEnvironment].offerGalleryFilterApiHeaders;
        this.replaceHeaderBanner(headerObj);
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
            }
        };
        return this._http.post(offersUrl, payload, options);
    }
    public filterCouponsByProgramType(data, programType: string) {
        let mappedCoupons = this.mapCoupons(data, true);
        let objCoupons = mappedCoupons['coupons'];
        let coupons = [];
        if (objCoupons) {
            coupons = Object.values(data['offers'])?.filter((coupon: any) => {
                if (coupon?.programType?.toUpperCase() === programType.toUpperCase()) {
                    return coupon;
                }
                return false
            });
        }
        return coupons;
    }
    public replaceHeaderBanner(header) {
        if (header) {
            if (header['banner']) {
                header['banner'] = header['banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy_banner']) {
                header['x-swy_banner'] = header['x-swy_banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy-banner']) {
              header['x-swy-banner'] = header['x-swy-banner'].replace(/\{banner\}/g, this.banner);
          }
        }
    }
    public getHiddenEventsMapping(data) {
        let coupons = [];
        let couponsClipped = [];
        if (data && data.offers) {
            data.offers.forEach(coupon => {
                coupon['clipStatus'] = coupon['deleted'] ? 'U' : coupon['clipStatus'];
                if (coupon['clipStatus'] == 'C') {
                    let couponId = (typeof coupon['couponID'] == 'undefined') ? coupon['offerId'] : coupon['couponID'];
                    couponsClipped = [...couponsClipped, couponId];
                }
                let endDate = coupon['offerEndDt'];
                coupon['status'] = coupon['clipStatus'] ? coupon['clipStatus'] : "";
                coupon['category'] = coupon.category ? coupon.category : "";
                coupon['events'] = coupon['events'] ? coupon['events'] : [];
                coupon['brand'] = (coupon['titleDsc1'] ? coupon['titleDsc1'] : "") + (coupon['titleDsc2'] ? " " + coupon['titleDsc2'] : "") + (coupon['titleDsc3'] ? " " + coupon['titleDsc3'] : "");
                coupon['description'] = (coupon['prodDsc1'] ? coupon['prodDsc1'] : "") + (coupon['prodDsc2'] ? " " + coupon['prodDsc2'] : "") + (coupon['prodDsc3'] ? " " + coupon['prodDsc3'] : "");
                //hot fix for having coupons on hidden events page show correct expiration date
                if (endDate.indexOf('-') !== -1) {
                    coupon['endDate'] = endDate.split('-')[1] + '/' + endDate.split('-')[2] + '/' + endDate.split('-')[0];
                } else {
                    coupon['endDate'] = endDate ? new Date(endDate).getTime() : "";
                }
                coupon['startDate'] = coupon['offerStartDt'] ? new Date(coupon['offerStartDt']).getTime() : "";
                coupon['offerPrice'] = coupon['savingsValue'] ? coupon['savingsValue'] : "";
                coupon['imageId'] = coupon['imageId'] ? coupon['imageId'] : "";
                coupon['image'] = window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon['imageId'];
            });
            coupons = data.offers;
        }
        return coupons;
    }

    public clipCoupon(coupon, userInfo): Observable<any> {
        let clipUrl = this.authService.getApplicationDomainURL() + window['AB']['couponClipPath'] + "?storeId=" + userInfo.j4uStoreId;
        let headerObj = window['AB'].j4uHttpOptions;
        const options = {
            headers: {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.authToken}`,
            }
        };
        let reqBody = {};

        if (coupon.deleted) {
            reqBody = {
                items: [
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        } else {
            reqBody = {
                items: [
                    {
                        clipType: 'C',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    },
                    {
                        clipType: 'L',
                        itemId: coupon.offerId,
                        itemType: coupon.offerPgm
                    }
                ]
            };
        }

        let result = this._http.post(clipUrl, reqBody, options).pipe(map((response) => {
            console.warn('clip response', response);
            if (response && response['items']) {
                if (response['items'][0]['status'] == 1) {
                    coupon.status = 'C';
                    coupon.deleted = false;
                    // Local Storage implementation
                    this.addUpdatedCouponToLS(coupon)
                    this.couponUpdated.next({id: coupon.offerId, deleted: false, status: 'C'});
                    this.clipEcomGalleryCoupon(coupon.offerId);

                    // update analytics data layer
                    let _coupon = {
                        "brand": coupon['instantAllocation'] ? 'welcome-offer-clip' : coupon.brand,
                        "offerType": coupon.offerPgm,
                        "offerId": coupon.offerId,
                        "offerPrice": coupon.offerPrice,
                        "carouselSection": window && window['digitalData'] && window['digitalData']['productInfo'] && window['digitalData']['productInfo'].carouselSection || ''
                    };
                    

                } else if (response['items'][0]['status'] == 0) {
                    $('#errorModal').modal({'show': true});
                    let strError = "200: Coupon Expired";
                    if (response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }
                    console.error(coupon.offerId.toString(), 'coupon clipping', strError);
                } else {
                    $('#errorModal').modal({'show': true});
                    let strError = "200: Coupon Clip failed - status is not either 0 or 1";
                    if (response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }
                    console.error(coupon.offerId.toString(), 'coupon clipping', strError);
                }

            } else {
                $('#errorModal').modal({'show': true});
                let strError = "200: Coupon Clip failed - items is not defined ";
                if (response['errorCd'] && response['errorMsg']) {
                    strError += " " + response['errorCd'] + " " + response['errorMsg'];
                }

                console.error(coupon.offerId.toString(), 'coupon clipping', strError);
            }
            return response;
        }, err => {
            console.error('clip error', err);
            let strError = err.status + ": Coupon Clip failed";
            if (typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
            }
            console.error(coupon.offerId.toString(), 'coupon clipping', strError);
            return null;
        }));

        return result;
    }

    addUpdatedCouponToLS(coupon) {
      let abJ4uItem = localStorage.getItem('abJ4uCoupons')
      if (this.isLSCompatible() && abJ4uItem !== undefined) {
        let abJ4uCoupons = JSON.parse(abJ4uItem);
        if (abJ4uCoupons) {
            let objCoupons = abJ4uCoupons['objCoupons'];
            if (objCoupons && objCoupons[coupon.offerId] != undefined) {
                let tempCoupon = objCoupons[coupon.offerId];
                tempCoupon.status = 'C';
                tempCoupon.deleted = false;
                /* custom code for instant allocation
                 * can be deleted once campaign is completed */
                if (tempCoupon.instantAllocation == true) {
                    abJ4uCoupons['instantAllocOffer'] = [];
                    tempCoupon.instantAllocation = undefined;
                }

            }
            abJ4uCoupons['arrClippedCoupons'] = [...abJ4uCoupons['arrClippedCoupons'], coupon.offerId];
            localStorage.abJ4uCoupons = JSON.stringify(abJ4uCoupons);
        }
    }
    }

    public clipEcomGalleryCoupon(couponId) {
        let objOffer = this.getOffer(couponId);

        if (this.isLSCompatible() && localStorage && objOffer != '') {
            let allCoupons = JSON.parse(localStorage.getItem('abCoupons'));
            if (allCoupons && allCoupons.offers && allCoupons.offers[couponId]) {
                allCoupons.offers[couponId].status = 'C';
                allCoupons.offers[couponId].deleted = false;
                this._set(allCoupons, false);
                this.shopCouponRefreshSource.next(true);
            }
        } else if (this.objPageCoupons['offers'][couponId]) {
            const coupon = this.objPageCoupons['offers'][couponId];
            coupon.status = 'C';
            coupon.deleted = false;
            this.shopCouponRefreshSource.next(true);
        }
    }

    public getOffer(offerId) {
        let objOffers = '';
        let objCoupons = this._get();
        if (objCoupons && objCoupons.offers && objCoupons.offers[offerId]) {
            objOffers = objCoupons.offers[offerId];
        }
        return objOffers;
    }

    public isLSCompatible() {
        let test = 'test';
        try {
            if (typeof window['AB'].isLSEnabled == 'undefined') {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                console.log('==== LOCAL STORAGE IS ENABLED ====');
                window['AB'].isLSEnabled = true;
            }
        } catch (e) {
            console.log('==== LOCAL STORAGE IS DISABLED ====');
            window['AB'].isLSEnabled = false;
        }
        return window['AB'].isLSEnabled;
    }

    private mapCoupons(data, isLtoEnabled? : boolean) {
        let couponsClipped = [];
        let coupons = [];
        let instantAllocOffer = [];
        let offers = (isLtoEnabled)? data?.offers: data?.companionGalleryOffer;
        if (offers != null) {
            for (let index in offers) {
                let coupon = offers[index];
                if (coupon != undefined) {
                    coupon.status = coupon.deleted ? 'U' : coupon.status;
                    coupon.offerType = (coupon.offerPgm == "PD") ? "PD" : "CC";
                    coupon.category = coupon.category ? coupon.category : coupon.categoryType;
                    coupon.brand = coupon.brand ? coupon.brand : coupon.name;
                    coupon.events = coupon.events ? coupon.events : [];
                    coupon.image = coupon.image ? coupon.image : window['SWY'].CONFIGSERVICE.nimbusConfig.couponImageBaseUrl + coupon.imageId;
                    if (coupon.status == 'C') {
                        couponsClipped = [...couponsClipped, coupon.offerId];
                    } else {
                        for (let event of coupon.events) {
                            if (event == 'Welcome Offers') {
                                instantAllocOffer.push(coupon);
                                coupon.instantAllocation = true;
                            }
                        }
                    }
                }
            }
            coupons = offers;
        } else if (data && data.offers != null) {
            coupons = this.getHiddenEventsMapping(data);
        }
        let response = {
            coupons,
            instantAllocOffer,
            couponsClipped
        };
        return response;
    }

    private _get(): any {
        let objCoupons = this.objCoupons;
        if (this.isLSCompatible() && Object.keys(objCoupons).length === 0) {
            let strCoupons = localStorage.getItem('abCoupons');
            try {
                if (strCoupons) {
                    objCoupons = JSON.parse(strCoupons);
                    this.objCoupons = objCoupons;
                }
            } catch (e) {
                console.error('ERROR: COUPON - GETTING FROM LOCAL STORAGE');
                console.error(e);
            }
        }
        return objCoupons;
    }

    private _set(coupons, setDate: boolean = true) {
        if (setDate) {
            coupons['updatedTime'] = JSON.stringify(new Date());
        }
        if (this.isLSCompatible()) {
            localStorage.setItem('abCoupons', JSON.stringify(coupons));
        }
        this.objCoupons = coupons;
    }
}
